import { ProviderCache } from '../ProviderCache';
export const subFormProviderCache = new ProviderCache((provider, params) => provider.getSubForm(params), 30 * 1000 * 60);
